// Token expiry error handled - 23-08-24 - Dev Srini

import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { loginSuccess, loginFailure } from '../../redux/authSlice';
import { Button, TextField, Container, Typography, Paper, Box, Link, Modal, Grid, useMediaQuery } from '@mui/material';

import session_img from '../../assets/svg/session-img-1.svg'
import AppConfig from '../../AppConfig';



const Login = () => {
  const screen600px = useMediaQuery("(max-width : 600px)")

  const dispatch = useDispatch();

  const [credentials, setCredentials] = useState({
    username: '',
    password: '',
  });

  const [open, setOpen] = useState(false);

  useEffect(() => {
    const sessionExpired = localStorage.getItem("sessionExpired")
    if (sessionExpired) {
      setOpen(true);
    }
  }, [])

  const handleClose = () => {
    localStorage.clear()
    window.location.replace(AppConfig.appRedirectUrl);
  }

  const handleInputChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value,
    });
  };

  const signup = () => {
    window.open("https://kyc.tradeboss.co/")
  }

  const handleLogin = () => {
    // Assuming you dispatch one of the login actions based on success or failure
    if (credentials.username === "kiran@bullforce.co" && credentials.password === "18Mar2024") {
      dispatch(loginSuccess({ /* user data */ }));
      window.location.href = '/dashboard';
    } else {
      alert('Login Authentication Failed');
      dispatch(loginFailure('Authentication failed'));
    }
  };

  return (
    <Container component="main" maxWidth="xs" sx={{ padding: "10%" }}>
      <Paper elevation={3} sx={{ padding: 3, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h5">
          Login
        </Typography>
        <Box component="form" noValidate sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            label="Username"
            name="username"
            value={credentials.username}
            onChange={handleInputChange}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            label="Password"
            name="password"
            type="password"
            value={credentials.password}
            onChange={handleInputChange}
          />
          <Button type="button" fullWidth variant="contained" onClick={handleLogin} sx={{ mt: 3 }}>
            Login
          </Button>
          <Box mt={2}>
            <Typography variant="body2">
              Don't have an account?{' '}
              <Link underline="hover"
                onClick={signup}
              >
                Sign Up
              </Link>
            </Typography>
          </Box>
        </Box>

        <Modal
          open={open}
          sx={{ border: 'none' }}>
          <Box className='semodal'>
            <Grid sx={{ display: 'flex', justifyContent: 'center' }} className='sessionimg' mt="10px" >
              <img src={session_img} alt='Session_img'></img>
            </Grid>

            <Grid sx={{ display: 'flex', justifyContent: 'center', marginTop: '4%' }} >
              {!screen600px ? (
                  <Typography className='sessionexp'>
                  Please Re-login to the Trading Platform
                  </Typography>
                ) : (
                  <Typography className='sessionexp'>
                    Please Re-login the Trading App
                  </Typography>
                )}
            </Grid>
            <Grid sx={{ display: 'flex', justifyContent: 'center', marginTop: '4%' }} >
              <Typography className='sehear1'>
                Your session has expired
              </Typography>
            </Grid>

            {!screen600px && <>
              <Grid sx={{ display: 'flex', justifyContent: 'center', marginTop: '4%' }} >
                <Button sx={{ width: '100px' }}
                  onClick={handleClose}
                >
                  ok
                </Button>
              </Grid>
            </>
            }
          </Box>
        </Modal>
      </Paper>
    </Container>
  );
};

export default Login;
